export const validateMinMaxProperties = (max, min, text) => {
  if (!max || !min) {
    return;
  }
  if (max < min) {
    // eslint-disable-next-line no-console
    console.warn(`Check your Max ${text} and Min ${text} properties.  Max should not be lower than min.`);
  }
};